/**
 * The plan the weekly checkup's calorie-baseline step hands to the solver.
 *
 * Kept free of Angular so a unit test can pin it (`weekly-checkup-solve-input.test.ts`), the same
 * way `weekly-checkup-outcome.ts` holds the outcome rule.
 */

import { deepClone } from '@cf-shared/deep-helpers';
import { FitnessPlan } from '@cf-shared/data-model/fitness-plan';

/**
 * A copy of `plan` with the intake the person says they ate last week as the target in force,
 * ready for the solve that works out the new target from their progress.
 *
 * The stored plan is never changed: the copy is only saved if the person accepts the adjustment.
 */
export function planForCheckupSolve(plan: Readonly<FitnessPlan>, calorieIntakeBaseline: number): FitnessPlan {
  const newPlan = deepClone(plan) as FitnessPlan;
  newPlan.actualDailyAverageIntake = newPlan.nominalDailyAverageIntake = Math.round(calorieIntakeBaseline);
  newPlan.skipNextNutritionAdjustment = undefined;
  newPlan.lastTimeMissedNutritionMacros_utc = undefined;
  // a "work the target out afresh" mark still stored on the plan is stale, so the checkup
  // adjusts from progress instead of from the formula (#4602,
  // design-docs/nutrition-target-persistence.md)
  delete newPlan.shouldInitializeBaselineAtNextReplan;
  return newPlan;
}
